"use client";
import type { Prisma } from "@-/prisma";
import { createContext } from "react";
import type include from "./include";

export type TeamLayoutContext = {
  team: Prisma.TeamGetPayload<{ include: typeof include }>;
};

const LayoutContext = createContext<TeamLayoutContext>(null!);

export default LayoutContext;
